export const config = {
  serverURL: "https://api-nxtdev23.apps.mktnxt.com/api/v1.0",
  NXTServerURL: "https://{tenant}.mediascape-nxtdev23.apps.mktnxt.com",
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "nxtdev23",
  clientId: "3qsjluficc5a6jups2o067fhqa",
  cognitoDomain: "duplo-nonprod.auth.us-east-1.amazoncognito.com",
  identityProvider: "duplo-nonprod",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-dev.mediascape-dev.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_aCLCffalK",
};
